'use client';

import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { CrossXs } from '@lichtblick/photon/icons/symbols/cross-xs';
import classNames from 'classnames';
import { type FC, useState } from 'react';
import { RichText } from '../../helpers/RichText';
import type { InfoBannerType } from '../../types/storyblok';
import styles from './info-banner.module.scss';

export const InfoBanner: FC<InfoBannerType> = ({ ariaLabel, text, theme }) => {
  const [show, setShow] = useState(true);

  return show ? (
    <aside aria-label={ariaLabel} className={classNames(styles.banner, styles[`banner-bg-${theme}`])}>
      <div className={styles.content}>
        <Text>
          <RichText richText={text} />
        </Text>
      </div>
      <TextCTA
        ariaLabel="Banner schließen"
        as="button"
        className={styles['close-button']}
        icon={<CrossXs />}
        onClick={() => setShow(false)}
      />
    </aside>
  ) : null;
};
